/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".sign-up-checkbox[_ngcontent-%COMP%]{display:flex;align-items:flex-start}.sign-up-checkbox[_ngcontent-%COMP%]   label[_ngcontent-%COMP%]{padding-left:.5rem;font-size:.75rem}.form-terms-conditions[_ngcontent-%COMP%]{font-size:.75rem;color:#84949a}"];
export { styles as styles };
